import { HttpErrorResponse } from '@angular/common/http';

export class AddBeekeeperUserIdFailure {
    static readonly type = '[User] AddBeekeeperUserIdFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}
